import { pageTypes } from 'config/pageTypes';
import SGPHeroImage from 'assets/images/sgp/hero/sgp-general-hero-optimized.webp';
import AltContentImage from 'assets/images/sgp/5x5/alt-content-image.webp';
import Budget from 'assets/images/sgp/5x5/budget.webp';
import Efficiency from 'assets/images/sgp/5x5/efficiency.webp';
import Modern from 'assets/images/sgp/5x5/modernliving.webp';
import Organize from 'assets/images/sgp/5x5/organize.webp';
import Inventory from 'assets/images/sgp/5x5/inventory.webp';
import Location from 'assets/images/sgp/5x5/location.webp';
import Amenities from 'assets/images/sgp/5x5/amenities.webp';
import Related1 from 'assets/images/sgp/5x5/storage-unit-size.webp';
import Related2 from 'assets/images/sgp/5x5/how-storage-unit-measured.webp';
import Related3 from 'assets/images/sgp/5x5/5x5-storage.webp';
import Related4 from 'assets/images/sgp/5x5/50-things-fit-in-5x10.webp';
import Seasonal from 'assets/images/sgp/5x5/Seasonal.svg';
import Books from 'assets/images/sgp/5x5/books.svg';
import Furniture from 'assets/images/sgp/5x5/furniture.svg';
import Summer from 'assets/images/sgp/5x5/summer.svg';
import Hours from 'assets/images/sgp/5x5/24-hour.svg';
import Home from 'assets/images/sgp/5x5/home.svg';
import SaveMoney from 'assets/images/sgp/5x5/save-money.svg';
import VCImage from 'assets/images/sgp/5x5/5x5-size-guide.webp';
import fourColumnTableImage from 'assets/images/sgp/fourColumnTable.svg';
import twoColumnTableImage from 'assets/images/sgp/twoColumnTable.svg';
import threeColumnTableImage from 'assets/images/sgp/threeColumnTable.svg';

export const reviews = [
	{
		reviewTitle: 'Great service.',
		reviewRating: 5,
		reviewText:
			"I was promptly set up with a nice, clean 5x5 unit.  The SpareFoot service was excellent. I'm very happy with your help.By David Alvarez",
		reviewerInitials: 'DA',
		link: 'https://www.trustpilot.com/reviews/5ee6e23c7dd7530828c0f18b',
		reviewerName: 'David Alvarez',
	},
	{
		reviewTitle: 'SpareFoot has what you need.',
		reviewRating: 5,
		reviewText:
			"Making a move across the country, I wanted an inexpensive 5x5 unit. Well, SpareFoot had it.The size and at a price I can afford. Close to where I'll be. I'm glad that I was able to find just what I needed.",
		reviewerInitials: 'T',
		link: 'https://www.trustpilot.com/reviews/57fb387ba43068088c1c6b5d',
		reviewerName: 'Terry',
	},
	{
		reviewTitle: 'Good customer service and great pricing.',
		reviewRating: 5,
		reviewText:
			'I called SpareFoot to reserve a 5x5 storage space from this company. My customer experience with them was great. I called the company from their website, and the next day, a manager at the storage facility called me and let me know they were holding it for me',
		reviewerInitials: 'D',
		link: 'https://www.trustpilot.com/reviews/52f026de000064000274e0c1',
		reviewerName: 'Devan',
	},
	{
		reviewTitle: "Saw a great price! Couldn't beat it!",
		reviewRating: 5,
		reviewText:
			'I was looking for a cheaper 5x5 storage unit, and when I did a search,I saw SpareFoot. I called and made the appointment and reserved the unit the same day, within the same hour.',
		reviewerInitials: 'J',
		link: 'https://www.trustpilot.com/reviews/52ba119a00006400026cd592',
		reviewerName: 'John',
	},
];

export const faqs = [
	{
		question:
			'How big is a 5x5 storage unit and what can I realistically fit inside?',
		answer: 'A 5x5 storage unit provides 25 square feet of floor space – roughly the size of a large walk-in closet or small bathroom. With standard 8-foot ceilings, you get about 200 cubic feet of total storage capacity, which is surprisingly spacious when organized vertically.\n\nWhat can fit in a 5x5 storage unit includes 15-20 boxes of seasonal items, a small furniture piece like a dresser or bookshelf, seasonal clothing in wardrobe boxes, and small appliances. Students often store textbooks, dorm furniture, and seasonal gear, while apartment dwellers use them for holiday decorations, out-of-season clothing, and keepsakes.',
	},
	{
		question:
			'What does a 5x5 storage unit look like and how should I organize it?',
		answer: "A 5x5 storage unit looks like a small room or large closet – it's 5 feet wide by 5 feet deep with 8-foot ceilings. The space typically has concrete floors, metal walls, and a roll-up door. While compact, it's surprisingly functional when organized properly.\n\nFor organization, think of it as a 3D puzzle. Use the walls for support and stack boxes in columns, leaving a small pathway to access items. Install simple shelving units along one wall to create organized zones for different categories. Keep frequently accessed items at eye level and seasonal items higher up.",
	},
	{
		question:
			"What's the typical 5x5 storage unit price, and what affects the cost?",
		answer: 'The 5x5 storage unit price typically ranges from $35 to $120 per month, with most people paying between $45-$75, depending on location and features. Rural areas average around $45 monthly, suburban locations cost about $60, while major cities can reach $95 or more.\n\nSeveral factors affect pricing: location is the biggest factor, with urban areas costing significantly more than rural locations. Climate control adds $20-$40 monthly but protects items from temperature and humidity damage. Indoor access facilities typically charge $10-$20 more but offer better security and weather protection.',
	},
	{
		question: 'Do I need climate control for my 5x5 storage unit?',
		answer: "Climate control isn't essential for all items, but it's worth considering based on what you're storing and your local climate. Standard 5x5 storage works well for clothing, books, household items, and holiday decorations in moderate climates. However, climate control becomes important for electronics, wooden furniture, important documents, photographs, or anything sensitive to temperature swings.\n\nConsider climate control if you live in an area with extreme temperatures, high humidity, or dramatic seasonal changes. It's also smart for long-term storage – anything stored for more than six months benefits from stable conditions. The additional cost ($20-$40 monthly) often prevents damage from warping, mold, mildew, or electronic failures.",
	},
	{
		question: 'Can I use a 5x5 storage unit for business purposes?',
		answer: "Absolutely! A 5x5 storage locker is perfect for small businesses, freelancers, and entrepreneurs who need affordable storage for inventory, supplies, or documents. Common business uses include storing seasonal merchandise, office supplies, archived files, marketing materials, and small equipment.\n\nMany small businesses use 5x5 units as cost-effective alternatives to expensive office space or warehouse rentals. They're ideal for e-commerce sellers storing inventory, service providers keeping supplies and tools, or professionals archiving client files and documents.",
	},
	{
		question: 'How do I maximize space in my small 5x5 storage unit?',
		answer: 'Maximizing your 5x5 storage unit requires strategic planning and smart organization techniques. Start by using uniform, sturdy boxes that stack safely to about 6-7 feet high. Place heavier items on the bottom and lighter items on top, creating stable columns along the walls.\n\nUse vertical space efficiently by installing simple metal shelving units along one wall. This creates organized zones for different categories, making it easier to access items. Fill hollow items like small appliances, pots, or storage containers with other belongings to use every inch of space effectively.',
	},
];

const twoPanelBlock = {
	props: {
		type: 'two-panel',
		title: 'What Can Fit in a 5x5 Storage Unit?',
		suffix: 'A 5x5 storage unit size can accommodate more than you might think:',
		content: [
			{
				image: Seasonal,
				description:
					'### Seasonal Storage:\n\n' +
					'- Complete winter or summer wardrobe\n' +
					'- Holiday decorations and lights\n' +
					'- [Seasonal sports equipment](https://www.sparefoot.com/blog/10-tips-organizing-kids-sports-equipment)\n' +
					'- Outdoor cushions and small patio items',
			},
			{
				image: Books,
				description:
					'### Student Essentials:\n\n' +
					'- Textbooks and school supplies\n' +
					'- [Summer storage needs and dorm room extras](https://www.sparefoot.com/college-storage.html)\n' +
					'- Small appliances (mini fridge, microwave)\n' +
					'- Seasonal clothing and bedding',
			},
		],
	},
};

const threePanelBlock = {
	props: {
		type: 'three-panel',
		title: 'Real-Life Storage Examples',
		pageType: 'SGP',
		content: [
			{
				image: Furniture,
				description:
					'### Apartment Dweller Package:\n\n' +
					'- 15-20 boxes of seasonal items\n' +
					'- Small bookshelf or dresser\n' +
					'- Vacuum cleaner and cleaning supplies\n' +
					'- Seasonal clothing in wardrobe boxes',
			},
			{
				image: Books,
				description:
					'### College Student Setup:\n\n' +
					'- Dorm furniture (desk chair, small shelf)\n' +
					'- 3-4 semesters of textbooks\n' +
					'- Seasonal clothing and bedding\n' +
					'- Small electronics and appliances',
			},
			{
				image: Summer,
				description:
					'### Holiday Storage:\n\n' +
					'- Christmas tree and decorations\n' +
					'- Holiday dishes and serving items\n' +
					'- Seasonal lighting and yard decorations\n' +
					'- Gift wrap and storage containers',
			},
		],
	},
};

const threePanelBlock2 = {
	props: {
		type: 'three-panel',
		title: 'Budget-Friendly Storage Strategies',
		pageType: 'SGP',
		content: [
			{
				image: Hours,
				description:
					'### Best Times to Rent:\n\n' +
					'- Fall and winter typically offer lower rates\n' +
					'- Avoid peak moving season (May-September)\n' +
					'- Mid-week rentals sometimes get better deals',
			},
			{
				image: SaveMoney,
				description:
					'### Money-Saving Tips:\n\n' +
					'- Look for first-month-free promotions\n' +
					'- Compare facilities within 15 miles\n' +
					'- Ask about student, military, or senior discounts\n' +
					'- Consider annual payment discounts',
			},
			{
				image: Home,
				description:
					'### Smart Shopping Approach:\n\n' +
					'- Factor in total costs (rent + insurance + locks)\n' +
					'- Check for hidden fees in rental agreements\n' +
					'- Compare climate-controlled vs. standard pricing\n' +
					"- Read reviews to ensure you're getting good value",
			},
		],
	},
};

const alternateContentData1 = {
	title: 'Looking for a Small Storage Unit?',
	description:
		'If you’re here, chances are that you’re looking for a small storage unit to give your stuff a new home. Lucky for you, SpareFoot has a variety of storage unit sizes to suit your small storage needs. Here’s your Goldilocks storage unit menu to help you find the best storage space:',
	additionalProps: {
		paragraph: {
			color: 'black',
		},
	},
	content: [
		{
			title: '',
			image: AltContentImage,
			description:
				'**Medium Units:** 10x10, 10x15, 5x15\n\n' +
				'**Small Units:** 5x5 (*you are here*), 5x10, Mini storage, Storage lockers\n\n' +
				'**Large Units:** 10x20, 10x25, 10x30\n\n',
		},
	],
};

const alternateContentData2 = {
	title: 'Why a 5x5 Storage Unit Is Perfect for Minimal Storage Needs',
	additionalProps: {
		paragraph: {
			color: 'black',
		},
	},
	content: [
		{
			title: 'Budget-Friendly Storage That Works',
			image: Budget,
			description:
				"A 5x5 storage unit offers the most affordable entry point into self-storage without sacrificing functionality. Here's why it's ideal for smart storage:\n\n" +
				'- **Apartment dwellers**: Perfect for [seasonal clothing](https://www.sparefoot.com/blog/how-to-store-clothes), holiday decorations, and sentimental items\n\n' +
				'- **Students**: Store textbooks, dorm extras, and summer/winter gear between semesters\n\n' +
				'- **Minimalists**: Keep only what you need at home while preserving important belongings\n\n' +
				'- **Budget-conscious**: Get organized without breaking the bank',
		},
		{
			title: 'Maximum Efficiency, Minimal Cost',
			image: Efficiency,
			description:
				'5x5 self-storage units provide excellent value because they:\n\n' +
				'- Cost significantly less than larger units while meeting basic storage needs\n\n' +
				'- Fit easily into tight budgets without long-term financial commitments\n\n' +
				'- Require minimal organization effort – everything stays visible and accessible\n\n' +
				'- Work perfectly for short-term and seasonal storage needs',
		},
		{
			title: 'Smart Storage for Modern Living',
			image: Modern,
			description:
				"A 5x5 storage space adapts to your lifestyle without overwhelming your budget, whether you're storing:\n\n" +
				'- Seasonal clothing and accessories\n\n' +
				'- [Holiday decorations](https://www.sparefoot.com/blog/9-clever-ways-to-store-holiday-decorations) and keepsakes\n\n' +
				'- College textbooks and supplies\n\n' +
				'- Small furniture pieces\n\n' +
				'- Business documents and supplies',
		},
	],
};

const alternateContentData3 = {
	title: 'Maximizing Your 5x5 Storage Space',
	description: '',
	additionalProps: {
		paragraph: {
			color: 'black',
		},
	},
	content: [
		{
			title: 'Vertical Stacking Tips:',
			image: Organize,
			description:
				'- Use sturdy, uniform boxes for safe stacking\n\n' +
				'- Keep heavier items towards the bottom, with lighter items on top\n\n' +
				'- Stack items to about 6–7 feet high for safety\n\n' +
				'- Use shelving units to create clearly organized storage zones',
		},
		{
			title: 'Organization Hacks:',
			image: Inventory,
			description:
				'- Use clear bins to see contents easily\n\n' +
				'- Label everything on multiple sides\n\n' +
				'- Create a simple inventory list\n\n' +
				'- Keep frequently needed items at eye level',
		},
	],
};

const alternateContentData4 = {
	title: '5x5 Storage Unit Price Factors',
	description:
		'The cost of your 5x5 storage unit depends on several key factors:',
	additionalProps: {
		paragraph: {
			color: 'black',
		},
	},
	content: [
		{
			title: 'Location Impact:',
			image: Location,
			description:
				'- Rural areas offer the most affordable options\n\n' +
				'- Suburban locations balance cost and convenience\n\n' +
				'- Urban areas cost more but offer better accessibility\n\n' +
				'- Major cities command premium pricing due to higher demand',
		},
		{
			title: 'Facility Features:',
			image: Amenities,
			description:
				'- **Standard units**: Base pricing\n\n' +
				'- **Climate-controlled**: Add $20–$40 monthly\n\n' +
				'- **Indoor access**: Premium of $10–$20\n\n' +
				'- **Enhanced security**: Usually included at no extra cost',
		},
	],
};

const pageType = 'SGP';
export const content5x5 = {
	type: '5x5',
	pageType: pageTypes.SGP,
	sections: [
		{
			title: 'SGP Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'sgp-hero',
					props: {
						content: {
							pageType,
							title: 'Small Storage Unit, Big Impact: 5x5 Storage Units Near You',
							inputLabel: 'Find Your Ideal 5x5 Storage Unit',
							description:
								'Living in a [tiny apartment](https://www.sparefoot.com/blog/apartment-storage-ideas) but can\'t bear to throw away your stuff? A 5x5 storage unit might be the perfect solution for your space crunch. At just 25 square feet, it\'s compact and budget-friendly while still providing enough room for seasonal items, keepsakes, and those "just in case" belongings that make your home feel cramped. A 5x5 storage unit is often called mini storage, but it packs a mighty big punch.',
							image: SGPHeroImage,
							CTAText: 'Search 5x5 Storage',
						},
					},
				},
			],
		},
		{
			title: 'nearby units',
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Facilities Near',
					},
				},
			],
		},
		{
			title: 'Alternate Content Section 1',
			modules: [
				{
					type: 'alternatingContent',
					id: 'AlternatContent1',
					props: {
						props: alternateContentData1,
					},
				},
			],
		},
		{
			title: 'Alternate Content Section 2',
			background: 'gray',
			modules: [
				{
					type: 'alternatingContent',
					id: 'AlternatContent2',
					props: {
						props: alternateContentData2,
					},
				},
			],
		},
		{
			title: 'SGP size chart',
			pageType,
			modules: [
				{
					type: 'sizeChart',
					slug: 'size-chart-section',
					props: {
						title: '5x5 Storage Unit Size Guide & Comparison',
						suffix: '### Understanding Your Space: How Big is a 5x5 Storage Unit?',
						description:
							'A 5x5 storage unit provides 25 square feet of storage space with 8-foot ceilings (some facilities offer higher ceilings). To put this in perspective:',
						pageType,
						image: twoColumnTableImage,
						tableType: 'specialType',
						headers: [
							{
								label: 'Comparison',
								key: 'Comparison',
							},
							{
								label: 'Size',
								key: 'Size',
							},
						],
						rows: [
							{
								Comparison: '5x5 Storage Unit',
								Size: '25 sq ft',
							},
							{
								Comparison: 'Walk-in closet',
								Size: '25-35 sq ft',
							},
							{
								Comparison: 'Small bathroom',
								Size: '35-40 sq ft',
							},
							{
								Comparison: 'Half bathroom',
								Size: '15-25 sq ft',
							},
							{
								Comparison: 'Large pantry',
								Size: '20-30 sq ft',
							},
						],
					},
				},
			],
		},
		{
			title: 'Why You Should Store Your Boat at a Storage Facility',
			background: 'dark',
			modules: [
				{
					type: 'videoSection',
					props: {
						content: {
							title: 'What Does a 5x5 Storage Unit Look Like?',
							description:
								"Imagine a space that's:\n\n- 5 feet wide by 5 feet deep\n\n- About the size of a large walk-in closet\n\n- Tall enough to stack boxes 6-7 feet high safely\n\n- Cozy but surprisingly spacious when organized well",
						},
						imageSrc: VCImage,
					},
				},
			],
		},
		{
			title: 'SGP size chart',
			pageType,
			background: 'gray',
			modules: [
				{
					type: 'sizeChart',
					slug: 'size-chart-section',
					props: {
						pageType,
						title: 'Size Comparison Chart',
						isFullWidth: true,
						image: fourColumnTableImage,
						description:
							'The 5x5 storage unit is small but mighty, offering 25 square feet of storage space - perfect for seasonal decor, off-season clothing, documents, and closet overflow.\n\n' +
							'Here’s how the [5x5 compares to its larger counterparts](https://www.sparefoot.com/storage-unit-size-guide.html):',
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Square Footage',
								key: 'Square Footage',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
							{
								label: 'Average Monthly Cost',
								key: 'Average Monthly Cost',
							},
						],
						rows: [
							{
								'Unit Size': '5x5',
								'Square Footage': '25 sq ft',
								'Best For': 'Closet-sized storage',
								'Average Monthly Cost': '$35-$85',
							},
							{
								'Unit Size': '5x10',
								'Square Footage': '50 sq ft',
								'Best For': 'Small apartment extras',
								'Average Monthly Cost': '$65-$120',
							},
							{
								'Unit Size': '10x10',
								'Square Footage': '100 sq ft',
								'Best For': '1-2 bedroom apartment',
								'Average Monthly Cost': '$85-$180',
							},
							{
								'Unit Size': '10x15',
								'Square Footage': '150 sq ft',
								'Best For': '2-3 bedroom home',
								'Average Monthly Cost': '$120-$220',
							},
							{
								'Unit Size': '10x20',
								'Square Footage': '200 sq ft',
								'Best For': '3+ bedroom home',
								'Average Monthly Cost': '$150-$280',
							},
						],
					},
				},
			],
		},
		{
			title: 'Two Panel Block',
			modules: [
				{
					type: 'cardBlockContent',
					id: 'twoPanelBlock',
					props: twoPanelBlock,
				},
			],
		},
		{
			title: 'Three Panel Block',
			background: 'gray',
			modules: [
				{
					type: 'cardBlockContent',
					id: 'twoPanelBlock',
					props: threePanelBlock,
				},
			],
		},
		{
			title: 'Alternate Content Section 3',
			modules: [
				{
					type: 'alternatingContent',
					id: 'AlternatContent3',
					props: {
						props: alternateContentData3,
					},
				},
			],
		},
		{
			title: 'SGP size chart',
			background: 'gray',
			pageType,
			modules: [
				{
					type: 'sizeChart',
					slug: 'size-chart-section',
					props: {
						pageType,
						title: '5x5 Storage Unit Price & Cost Analysis (2025)',
						image: threeColumnTableImage,
						headers: [
							{
								label: 'Location Type',
								key: 'Location',
							},
							{
								label: 'Monthly Cost Range',
								key: 'Monthly Cost Range',
							},
							{
								label: 'Average Cost',
								key: 'Average Cost',
							},
						],
						rows: [
							{
								Location: {
									type: 'markdown',
									markdown: '**Rural Areas**',
								},
								'Monthly Cost Range': '$35-$55',
								'Average Cost': '$45',
							},
							{
								Location: {
									type: 'markdown',
									markdown: '**Suburban**',
								},
								'Monthly Cost Range': '$45-$70',
								'Average Cost': '$60',
							},
							{
								Location: {
									type: 'markdown',
									markdown: '**Urban**',
								},
								'Monthly Cost Range': '$60-$90',
								'Average Cost': '$75',
							},
							{
								Location: {
									type: 'markdown',
									markdown: '**Major Cities**',
								},
								'Monthly Cost Range': '$75-$120',
								'Average Cost': '$95',
							},
						],
					},
				},
			],
		},
		{
			title: 'Alternate Content Section 4',
			modules: [
				{
					type: 'alternatingContent',
					id: 'AlternatContent4',
					props: {
						props: alternateContentData4,
					},
				},
			],
		},
		{
			title: 'Three Panel Block2',
			background: 'gray',
			modules: [
				{
					type: 'cardBlockContent',
					id: 'twoPanelBlock',
					props: threePanelBlock2,
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			pageType,
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'Find a 5x5 Storage Unit with SpareFoot',
						pageType,
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: '5x5 Storage Unit FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						title: 'Learn More About Storage Unit Size Options',
						slug: 'sgp-featured-content',
						pageType,
						contentCards: [
							{
								title: 'General Storage Advice',
								date: 'August 7, 2025',
								image: Related1,
								link: 'https://www.sparefoot.com/blog/how-to-pick-the-right-size-storage-unit',
								content:
									'How to Pick the Right Size Self Storage Unit',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: Related2,
								link: 'https://www.sparefoot.com/blog/how-are-storage-units-measured',
								content: 'How Are Storage Units Measured?',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: Related3,
								link: 'https://www.sparefoot.com/blog/5x5-storage-unit-size-guide',
								content:
									'What Can You Fit Inside a 5x5 Storage Unit?',
							},
							{
								title: 'Self Storage',
								date: 'October 29, 2025',
								image: Related4,
								link: 'https://www.sparefoot.com/blog/50-things-you-can-store-in-5x10-storage-unit',
								content:
									'50 Things That Fit Inside a 5x10 Storage Unit',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other SGP',
			modules: [
				{
					type: 'links',
					props: {
						pageType: 'SGP',
						title: 'More Ways to Store',
						cards: [
							'ClimateControl',
							'Mini',
							'StorageLockers',
							'5x10',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						title: 'Popular Facilities Near',
					},
				},
			],
		},
	],
};
